import { cloneDeep } from 'lodash';

/**
 * Utility function to deep clone an object using structuredClone if available,
 * otherwise falling back to cloneDeep for compatibility.
 * @param {Object} obj - The object to deep clone
 * @returns {Object} - The deep cloned object
 */
export function deepClone(obj) {
	try {
		if (typeof structuredClone === 'function') {
			return structuredClone(obj);
		}
	} catch {
		return cloneDeep(obj);
	}
	return cloneDeep(obj);
}
